import React from 'react';
import Card from 'components/Card';
import TextArea from 'components/TextArea';
import Dropdown from 'components/Dropdown';
import Button from 'components/Button';
import { MessageFormContainer } from './styles';

const SendCustomerMessage = () => {

  //FIXME: update this when the backend is ready
  const loading=false
  const handleSend = () => {
    if(loading) return
    //TODO: add send logic
  }

  return (
    <Card>
      <MessageFormContainer>
        <TextArea      
          mainPage
          resize={'vertical'}
          title="SEND A MESSAGE TO THIS CUSTOMER"
          onChange={(e) => { }}
          additionalstyle={`
            flex-basis: 79%;
          `}
        />
        <Dropdown
          mainPage
          options={['Text Message']}
          value="Text Message"
          title="SEND AS"
          onChange={(e) => { }}
          additionalstyle={`
            flex-basis: 12%;
            margin-left: 2%;
            .select {
              height: 47px;
            }
          `}
        />
        <div>
          <Button
            mainPage
            onClick={handleSend}
            data-loading={loading}
            additionalstyle={`
              width: 65px;
              margin-top: 20px;
            `}
          >
            {loading ? null: 'Send'}
          </Button>
        </div>
      </MessageFormContainer>
    </Card>
  )
}

export default SendCustomerMessage;
